import { render, staticRenderFns } from "./PostingCardV2.vue?vue&type=template&id=501b9738"
import script from "./PostingCardV2.vue?vue&type=script&lang=ts"
export * from "./PostingCardV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingCardV2.vue?vue&type=style&index=0&id=501b9738&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501b9738')) {
      api.createRecord('501b9738', component.options)
    } else {
      api.reload('501b9738', component.options)
    }
    module.hot.accept("./PostingCardV2.vue?vue&type=template&id=501b9738", function () {
      api.rerender('501b9738', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jobboard/PostingCardV2.vue"
export default component.exports